import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/config.service';
import { SettingsService } from 'src/app/shared/settings.service';
import { environment } from '../../../environments/environment';
import { AppStateService } from '../../shared/app-state.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  connectionState = { class: 'text-danger', label: 'Verbinde zum Server...' };

  version = 'x.x.x';
  serverVersion = 'x.x.x';
  appState = 'App loading ...';
  loading = true;
  dev = environment.develop;

  constructor(private appStateService: AppStateService, private settingsService: SettingsService,
    private configService: ConfigService/*, public sseService: SSEService*/) { }

  ngOnInit() {
    this.appStateService.appReady$.subscribe(res => {
      this.loading = !res;
      this.appState = res ? 'loading finished' : 'App loading ...';
    });

    this.version = this.configService.configData.appVersion;
    this.settingsService.getServerVersion().subscribe(
      version => {
        this.serverVersion = version.number;
        this.connectionState = { class: 'text-success', label: 'verbunden' };
      }
    );

    // this.sseService.connectionState$.subscribe((state) => {

    // switch (state) {
    //   case 'connected':
    //     this.connectionState = { class: 'text-success', label: 'verbunden' };
    //     break;
    //   case 'connecting':
    //     this.connectionState = { class: 'text-warning', label: 'Verbinde zum Server...' };
    //     break;
    //   case 'unavailable':
    //     this.connectionState = { class: 'text-danger', label: 'Server nicht erreichbar' };
    //     break;
    //   default:
    //     this.connectionState = { class: 'text-secondary', label: 'unbekannt' };
    // }
    // });
  }

}
